<template>
  <GridBase our-idea>
    <h2><TextBlock file="about/our-idea-h2" class="pre-line"/></h2>

    <section class="sec1 j" data-offset="0">
      <PrSlideOrNot title="Our Goal" class="c1" :video="`${videoBase}/our-idea-01.mp4`" id="our-idea-v0">
        <template v-slot:top>
          <TextBlock file="about/our-idea-t1" class="pre-line stay q"/>
        </template>
        <template v-slot:stay>
          <TextBlock file="about/our-idea-t1" class="pre-line stay"/>
        </template>
        <template v-slot:slide>
          <ul class="split-view">
            <li data-p="0.2,0.8" data-a="0,1" data-y="50,0">
              <p>1초마다 검색되는 질문</p>
              <p><span>7400</span> <span>개</span></p>
            </li>
            <li data-p="0.3,0.9" data-a="0,1" data-y="50,0">
              <p>1초마다 발송되는 메일</p>
              <p><span>2500</span> <span>통</span></p>
            </li>
          </ul>
          <TextBlock data-p="0.4,1" data-a="0,1" data-y="50,0" file="about/our-idea-t2" class="pre-line"/>
        </template>
        <ul class="split-view">
          <li class="q">
            <p>1초마다 검색되는 질문</p>
            <p><span>7400</span> <span v-if="kr">개</span></p>
          </li>
          <li class="q">
            <p>1초마다 발송되는 메일</p>
            <p><span>2500</span> <span v-if="kr">통</span></p>
          </li>
        </ul>
        <TextBlock file="about/our-idea-t1" class="hidden-sm-down hidden-lg-up pre-line q"/>
        <TextBlock file="about/our-idea-t2" class="pre-line q"/>
      </PrSlideOrNot>
      <div class="c2 split-view">
        <div>
          <img src="/img/about/idea/idea-s1-c2-1.jpg" alt="" class="hidden-md-up">
          <img src="/img/about/idea/idea-s1-c2-1.png" alt="" class="hidden-sm-down">
          <h4>지속 가능한 내일</h4>
          <TextBlock file="about/our-idea-t4" class="pre-line"/>
        </div>
        <div>
          <img src="/img/about/idea/idea-s1-c2-2.jpg" alt="" class="hidden-md-up">
          <h4>미래를 위한 기술</h4>
          <TextBlock file="about/our-idea-t5" class="pre-line"/>
          <img src="/img/about/idea/idea-s1-c2-2.jpg" alt="" class="hidden-sm-down">
        </div>
      </div>
    </section>

    <section class="sec2">
      <GridBase class="c1" v-if="this.sect === 'sm' || this.sect === 'md'">
        <h3>Our Step</h3>
        <TextBlock file="about/our-idea-t7" class="pre-line q"/>
        <img v-if="this.sect === 'sm'" src="/img/about/idea/idea-s2-c1-1.s.png" alt="">
      </GridBase>
      <PrSlideOrNot id="our-idea-v1" img="/img/about/idea/idea-s2-c1-1.l.png" title="Our Step" direction="l2r" v-else class="j" data-offset="0">
        <template v-slot:slide>
          <TextBlock data-p="0.8,1" data-a="0,1" data-y="50,0" file="about/our-idea-t7" class="pre-line"/>
        </template>
      </PrSlideOrNot>
      <div class="c2">
        <div class="split-view">
          <div>
            <h4><TextBlock file="about/our-idea-t8" class="pre-line"/></h4>
            <TextBlock file="about/our-idea-t9" class="pre-line q"/>
            <img src="/img/about/idea/idea-s2-c2-1.png" alt="">
          </div>
          <div>
            <img src="/img/about/idea/idea-s2-c2-2.s.jpg" alt="" class="hidden-md-up">
            <img src="/img/about/idea/idea-s2-c2-2.jpg" alt="" class="hidden-sm-down">
          </div>
        </div>
      </div>
    </section>
    
    <section class="sec3">
      <div class="wrap" v-if="this.sect === 'sm'">
        <div class="mo-copy">
          <ul class="list">
            <li class="item" v-for="(item) in ideaCont" :key="item.title">
              <div class="image">
                <img :src="item.srcMo" alt="">
              </div>
              <div class="text">
                <h4 class="title" v-html="item.title"></h4>
                <p class="desc" v-html="item.desc"></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <StickyIdea id="ideaSec3" class="j" v-else data-offset="0" @fixed="sticky">
        <div class="wrap">
          <div class="copy">
            <ul class="list">
              <li class="item" v-for="(item) in ideaCont" :key="item.title">
                <div class="image">
                  <img :src="item.imgSrc" alt="">
                </div>
              </li>
            </ul>
          </div>
          <div class="scroll">
            <ul class="list">
              <li class="item" v-for="(item) in ideaCont" :key="item.title">
                <div class="text">
                  <h4 class="title" v-html="item.title"></h4>
                  <p class="desc" v-html="item.desc"></p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </StickyIdea>
    </section>

    <section class="bottom">
      <grid-base alpha50 class="c3">
        <TextBlock file="about/our-idea-t10" class="pre-line" in-only/>
      </grid-base>
      <quick-link>
        <quick-link-item><router-link to="our-brand">Our Brand</router-link></quick-link-item>
        <quick-link-item><router-link to="/gak/gak-sejong">GAK Sejong</router-link></quick-link-item>
      </quick-link>
    </section>
  </GridBase>
</template>
<script>
import GridBase from '../../components/GridBase';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';
import TextBlock from '@/views/components/TextBlock';
import PrSlideOrNot from '@/views/components/PrSlideOrNot';
import ideaCont from "@/data/data/ideaFeature";
import StickyIdea from "@/views/components/StickyIdea";
import { getOffsetLeft } from "@/utils";
import responsive from "@/utils/responsive";

export default {
  name: 'our-idea',
  components: { PrSlideOrNot, TextBlock, QuickLinkItem, QuickLink, GridBase, StickyIdea },
  data() {
    return {
      f5Active: -1,
      ideaCont,
      preScrollTop: 0,
      space: 0,
      resize: false
    }
  },
  mounted() {
    this.setElement();
    responsive.addListener(this.resized);
  },
  beforeDestroy() {
    responsive.removeListener(this.resized);
    window.removeEventListener('scroll', this.scrollMoveActive);
  },
  methods: {
    setElement() {
      this.header = document.querySelector('header .bar');
      this.sec3 = document.querySelector('.sec3');
      this.sec3Content = this.sec3.querySelector('.j');
      this.scroll = this.sec3.querySelector('.scroll');
      this.copyItem = this.sec3.querySelectorAll('.copy .item');
      this.image1 = this.copyItem[0];
      this.image2 = this.copyItem[1];
      this.image3 = this.copyItem[2];
      this.scrollItem = this.sec3.querySelectorAll('.scroll .item');
      this.text1 = this.scrollItem[0];
      this.text2 = this.scrollItem[1];
      this.text3 = this.scrollItem[2];
    },
    setElementSticky() {
      this.stickContainer = document.querySelector('.stick-container2');
      this.stickCover = this.stickContainer.querySelector('.stick-cover');
      this.stickScroll = this.stickContainer.querySelector('.scroll');
      this.stickSec3 = this.stickContainer.querySelector('.stick-container2 #ideaSec3');
      this.copy = this.stickSec3.querySelector('.copy');
      this.copyItem = this.stickSec3.querySelectorAll('.copy .item');
      this.image1 = this.copyItem[0];
      this.image2 = this.copyItem[1];
      this.image3 = this.copyItem[2];
      this.scrollItem = this.stickSec3.querySelectorAll('.scroll .item');
      this.text1 = this.scrollItem[0];
      this.text2 = this.scrollItem[1];
      this.text3 = this.scrollItem[2];
    },
    sticky(init) {
      if (init) {
        this.setElementSticky();
        this.copyFixed();
        responsive.addListener(this.resized);

        if (this.resize) {
          this.copyFixed();
        }
      } else {
        this.copyFixedReset();
      }
    },
    resetF5(idx, el) {
      this.f5Active = idx;
      const right =
        getOffsetLeft(el) +
        +el.parentNode.style.transform.match(/(-?\d+)px/)[1] +
        el.offsetWidth;
      if (right > window.innerWidth) this.$refs.f5slide.next();
    },
    scrollMove(refName) {
      this.$refs[refName].$el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollMoveActive() {
      const text1Top = -Math.floor(this.text1.getBoundingClientRect().top);
      const text1Height = Math.floor(this.text1.getBoundingClientRect().height);
      const text2Top = -Math.floor(this.text2.getBoundingClientRect().top);
      const text2Height = Math.floor(this.text2.getBoundingClientRect().height);
      const text3Top = -Math.floor(this.text3.getBoundingClientRect().top);
      const text3Height = Math.floor(this.text3.getBoundingClientRect().height);
      let n;

      const viewportHeight = window.innerHeight;
      
      if (text1Top <= (viewportHeight / 3) - this.space) {
        // text1 영역
        n = 0;
        // copy img 연동
        let nextScrollTop = window.scrollY;

        if (this.preScrollTop < nextScrollTop) {
        // scroll down
          
          if (text1Top <= text1Height) {
            this.image1.classList.add('is-active');
          } else {
            this.image1.classList.add('is-hide');
            this.image1.classList.remove('is-active');
          }
        } else {
          // scroll up
          
          this.copyItem.forEach(function (el) {
            el.classList.remove('is-hide');
          })

          if (text1Top <= text1Height) {
            this.image1.classList.remove('is-hide');
            this.image1.classList.add('is-active');
          } else {
            this.image1.classList.add('is-hide');
            this.image1.classList.remove('is-active');
          }
        }
        this.preScrollTop = nextScrollTop;

      } else if (text2Top <= (viewportHeight / 3) - this.space) {
        // text2 영역
        n = 1;
        // copy img 연동
        let nextScrollTop = window.scrollY;

        if (this.preScrollTop < nextScrollTop) {
          // scroll down
          
          if (text2Top <= text2Height) {
            this.image1.classList.add('is-hide');
            this.image1.classList.remove('is-active');
            this.image2.classList.remove('is-hide');
            this.image2.classList.add('is-active');
            
          } else {
            this.image2.classList.add('is-hide');
            this.image2.classList.remove('is-active');
          }
        } else {
          // scroll up
          this.copyItem.forEach(function (el) {
            el.classList.remove('is-hide');
          })

          if (text2Top <= text2Height) {
            this.image2.classList.add('is-hide');
            this.image2.classList.remove('is-hide');
          } else {
            this.image3.classList.add('is-hide');
            this.image3.classList.remove('is-active');
            this.image2.classList.remove('is-hide');
            this.image2.classList.add('is-active');
          }
        }
        this.preScrollTop = nextScrollTop;

      } else {
        // text3 영역
        n = 2;
        // copy img 연동
        let nextScrollTop = window.scrollY;

        if (this.preScrollTop < nextScrollTop) {
          // scroll down
          
          if (text3Top <= text3Height) {
            this.image2.classList.add('is-hide');
            this.image2.classList.remove('is-active');
            this.image3.classList.remove('is-hide');
            this.image3.classList.add('is-active');
            
          }
        } else {
          // scroll up
          this.copyItem.forEach(function (el) {
            el.classList.remove('is-hide');
          })

          if (text3Top <= text3Height) {
            this.image3.classList.add('is-active');
          }
        }
        this.preScrollTop = nextScrollTop;
      }

      this.copyItem.forEach(function (el) {
        el.classList.remove('is-active');
      })
      this.copyItem[n].classList.add('is-active');
    },
    setStickyHeight() {
      const coverEl = document.querySelector('.stick-cover');
      const sec3Content = document.querySelector('.sec3 .j');

      if (coverEl !== null) {
        const coverElHeight = coverEl.offsetHeight;
        sec3Content.style.height = coverElHeight + 'px';
      }
    },
    copyFixed() {
      this.copy.classList.add('is-fixed');
    },
    copyFixedReset() {
      this.copy.classList.remove('is-fixed');
    },
    resized(section) {
      if (section.section !== 'sm') {
        this.setStickyHeight();

        const headerHeight = this.header.offsetHeight;
        this.space = headerHeight;
        this.resize = true;
        window.addEventListener('scroll', this.scrollMoveActive);

        if (window.innerWidth <= window.innerHeight) {
          this.space = 100;
        }

        if (section.section === 'xxl') {
          this.space = 300;
          if (window.innerWidth <= 1920) {
            this.space = 350;
          }
        } else if (section.section === 'lg') {
          this.space = 250;
        } else if (section.section === 'md') {
          this.space = 180;
        }
      }
    },
  }
}
</script>
